import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from "@angular/core";
import { Router } from "@angular/router";
import { ModalController, NavController } from "@ionic/angular";
import { AppService } from "src/app/_services/app.service";
import { ClientService } from "src/app/_services/client.service";
import { LocalStorageService } from "src/app/_services/localStorage.service";
import { ProviderService } from "src/app/_services/provider.service";

@Component({
  selector: "app-cancel-modal",
  templateUrl: "./cancel-modal.component.html",
  styleUrls: ["./cancel-modal.component.scss"],
  standalone: false,
})
export class CancelModalComponent implements OnInit, OnChanges {
  @Input() price?: number | string;
  @Input() validButtonText?: string;
  @Input() cancleButtonText?: string;
  @Input() title?: string;
  @Input() description?: string;
  @Input() demandId?: number | string;
  @Input() cancelType = "";
  @Output() valid: EventEmitter<void> = new EventEmitter<void>();
  @Output() dismissModal = new EventEmitter<void>();
  role: any;
  loading: boolean = false;

  constructor(
    private appService: AppService,
    private clientService: ClientService,
    private localStorageServices: LocalStorageService,
    private router: Router,
    private navController: NavController,
    private providerService: ProviderService,
    private modalController: ModalController
  ) {
    this.role = this.localStorageServices.getUserRole();

    this.subscribeCancelModal();
  }
  devisId!: number | string;
  type: string = "";

  ngOnInit() {
    this.applyDemandContextFromInputs();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["demandId"] || changes["cancelType"]) {
      this.applyDemandContextFromInputs();
    }
  }

  private applyDemandContextFromInputs(): void {
    if (this.demandId != null && this.demandId !== "") {
      this.devisId = this.demandId;
    }
    if (this.cancelType) {
      this.type = this.cancelType;
    }
  }

  private notifyDismiss(): void {
    this.dismissModal.emit();
    this.modalController.dismiss().catch(() => undefined);
  }

  handleCancelModal(val: boolean) {
    this.appService.dispatchModal("CANCEL_DEMAND_MODAL", { open: val });
    if (!val) {
      this.notifyDismiss();
    }
  }
  closeModal() {
    this.appService.dispatchModal("CANCEL_DEMAND_MODAL", { open: false });
    this.appService.dispatchModal("CANCELED_DEVIS_MODAL", { open: true });
    this.notifyDismiss();
  }
  subscribeCancelModal() {
    this.appService.cancelModalObservable().subscribe((val: any) => {
      if (val.open) {
        if (val.id != null && val.id !== "") {
          this.devisId = val.id;
        }
        if (val.type) {
          this.type = val.type;
        }
      }
    });
  }
  cancleDemand(reason: string = "new-devis") {
    this.providerService
      .cancelDemande({
        demande_id: this.devisId,
        type: reason,
      })
      .subscribe((res: any) => {
        this.handleCancelModal(false);
        this.localStorageServices.dropCurrentDemand();
        this.loading = false;
        this.notifyDismiss();
        setTimeout(() => {
          this.goTo("");
        }, 100);
      });
  }
  cancleDemandByClient(reason: string = "new-devis") {
    let payload = {
      id: this.devisId,
      statut: "CANCELED",
    };
    this.clientService.cancleDemand(payload).subscribe((res: any) => {
      this.loading = false;
      this.handleCancelModal(false);
      this.notifyDismiss();
      setTimeout(() => {
        this.goTo("");
      }, 100);
    });
  }

  cancleOnRoadDemand() {
    let payload = {
      id: this.devisId,
    };
    this.loading = true;
    if (this.type === "provider") {
      this.cancleDemand();
    } else if (this.type === "client") {
      this.cancleDemandByClient();
    } else {
      this.clientService.cancleOnRoadDemand(payload).subscribe((res: any) => {
        this.loading = false;
        this.handleCancelModal(false);
        this.localStorageServices.dropCurrentDemand();
        this.notifyDismiss();
        setTimeout(() => {
          this.goTo("");
        }, 100);
      });
    }
  }
  goTo(path: string) {
    let baseUrl = "";
    switch (this.role) {
      case "client":
        baseUrl = "particulier";
        break;
      case "prestataire":
        baseUrl = "prestataire";
        break;
    }

    setTimeout(() => {
      this.navController.navigateForward(["/" + baseUrl + "/" + path]);
    }, 500);
  }
}
